import React, { Component } from "react";
// import { layout, roles, messages } from '../../../common/constants'
import { Bar } from "react-chartjs-2";
// import * as charts from './_charts'
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getCustomersByPrefix } from "../../store/customer/actions";
import { getItemListByPrefix, addSell } from "../../store/sell/actions";
import {
  Row,
  Button,
  Col,
  Card,
  CardHeader,
  CardBody,
  Alert,
  Collapse,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
} from "reactstrap";
// import { formatHelper } from '../../../common/helpers'
// import { getStores } from '../../../store/store/actions'
// import { selectUserRole } from '../../../store/user/selector'
// import { selectStoresForSelect } from '../../../store/store/selector'
import Select from "react-select";
import Autosuggest from "react-autosuggest";
import { throws } from "assert";
import AutosuggestField from "../../components/AutosuggestField/AutosuggestField";
import {
  Item,
  ItemList,
  ItemModal,
  SellModal,
} from "../../components/RemoteSellComponents";

class RemoteSells extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customerInput: "",
      itemInput: "",
      modalOpen: false,
      page: 1,
      selected: false,
      selectedItem: null,
      selectedItems: [],
      sellModalOpen: false,
      suggestions: [],
      total: 0.0,
      value: "",
    };

    this.onChange = this.onChange.bind(this);
    this.onCustomerChange = this.onCustomerChange.bind(this);
    this.onItemChange = this.onItemChange.bind(this);
    this.selectItem = this.selectItem.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeSellModal = this.closeSellModal.bind(this);
    this.pushItemToArray = this.pushItemToArray.bind(this);
    this.onCompleteSell = this.onCompleteSell.bind(this);
  }

  async componentDidMount() {
    const { page } = this.state;
    // this.props.getCustomersByPrefix('P', false)
    // this.props.getItemListByPrefix('S', false)
  }

  async onCustomerChange(newValue) {
    await this.setState({ customerInput: newValue });
    this.props.getCustomersByPrefix(newValue, false);
  }

  async onItemChange(newValue) {
    await this.setState({ itemInput: newValue });
    this.props.getItemListByPrefix(newValue, false);
  }

  onChange(event, { newValue, method }) {
    const { selected } = this.state;
    if (!selected) {
      this.setState({
        value: newValue,
      });
    }
  }

  async selectItem(item) {
    await this.setState({ selectedItem: item, modalOpen: true });
  }

  async closeModal() {
    this.setState({ modalOpen: false });
  }

  async closeSellModal() {
    this.setState({ sellModalOpen: false });
  }

  async editItem(item) {
    console.log("item", item);
  }

  openSellModal() {
    this.setState({ sellModalOpen: true });
  }

  renderItemModal() {
    const { selectedItem, modalOpen } = this.state;
    if (selectedItem != null) {
      return (
        <ItemModal
          isOpen={modalOpen}
          item={selectedItem}
          onAccept={this.pushItemToArray}
          onCancel={this.closeModal}
        />
      );
    }
  }

  renderSellModal() {
    const { total, sellModalOpen } = this.state;
    if (total != null) {
      return (
        <SellModal
          isOpen={sellModalOpen}
          total={total}
          onCompleteSell={this.onCompleteSell}
          onCancel={this.closeSellModal}
        />
      );
    }
  }

  renderSelectedItems() {
    const { selectedItems } = this.state;
    if (selectedItems != null) {
      const listItems = selectedItems.map((item) => {
        return (
          <div className="div-item" key={item.id}>
            <Row>
              <Col md="6" lg="6">
                {item.name}
              </Col>
              <Col>{item.price}</Col>
              <Col>{item.quantity}</Col>
              <Col>
                <Button color="primary" onClick={() => this.editItem(item)}>
                  {" "}
                  Editar{" "}
                </Button>
              </Col>
            </Row>
          </div>
        );
      });

      return listItems;
    }
  }

  pushItemToArray(item) {
    const { selectedItems } = this.state;
    selectedItems.push(item);
    this.setState({ selectedItems, modalOpen: false });
  }

  onCompleteSell(params, sell) {
    const { selectedItems, total } = this.state;
    const data = { selectedItems, total };
    this.props.addSell(params, sell);
  }

  render() {
    const { value, suggestions } = this.state;
    return (
      <div>
        <Card>
          <CardHeader onClick={() => {}}>Venta</CardHeader>
          <CardBody>
            <Row className="my-4">
              <Col>
                <AutosuggestField
                  values={this.props.customerList.customers}
                  label={"Cliente"}
                  onChange={this.onCustomerChange}
                  type="1"
                />
              </Col>
            </Row>
            <Row className="my-4">
              <Col>
                <AutosuggestField
                  values={this.props.itemList.items}
                  label={"Producto / Servicio"}
                  onChange={this.onItemChange}
                  type="2"
                  onItemSelected={this.selectItem}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                {/* <div className="w90"> */}
                Items
                <div className="div-item-list">
                  <Row>
                    <Col md="6" lg="6">
                      Producto / Servicio
                    </Col>
                    <Col>Precio</Col>
                    <Col>Cantidad</Col>
                    <Col>Opciones</Col>
                  </Row>
                  {this.renderSelectedItems()}
                </div>
                {/* </div> */}
              </Col>
            </Row>
            <Row className="my-4">
              <Col>
                <Button
                  color="primary"
                  onClick={() => this.openSellModal()}
                  className="w100"
                >
                  Continuar
                </Button>
              </Col>
            </Row>
          </CardBody>
        </Card>

        {this.renderItemModal()}
        {this.renderSellModal()}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { customerList } = state.customer;
  const { itemList } = state.sell;
  return {
    customerList,
    itemList,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getCustomersByPrefix,
      getItemListByPrefix,
      addSell,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(RemoteSells);



// WEBPACK FOOTER //
// ./src/scenes/RemoteSells/RemoteSells.js